import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumRename = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.300049 6.94283C0.300049 5.74955 1.31015 4.84283 2.48111 4.84283H3.49183C3.67822 4.84283 3.85691 4.91717 3.9883 5.04937C4.1197 5.18156 4.19295 5.3607 4.19182 5.54709L4.16179 10.4899C4.15946 10.8749 3.84675 11.1857 3.46181 11.1857H2.4711C1.90497 11.1857 1.35085 10.9668 0.947778 10.5832C0.543618 10.1986 0.300049 9.6554 0.300049 9.08569V6.94283ZM7.87546 5.54283C7.87546 5.15624 8.18886 4.84283 8.57546 4.84283H13.519C14.6768 4.84283 15.7 5.74657 15.7 6.94283V9.08569C15.7 10.279 14.69 11.1857 13.519 11.1857H8.57546C8.18886 11.1857 7.87546 10.8723 7.87546 10.4857V5.54283Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4.4624 3H7.51458",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4.4624 13H7.51458",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M5.98364 3V13",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M8.57541 5.54285H13.5189C14.3295 5.54285 15 6.17142 15 6.94285V9.0857C15 9.85713 14.3395 10.4857 13.5189 10.4857H8.57541M3.46176 10.4857H2.47105C2.08077 10.4857 1.7005 10.3333 1.43031 10.0762C1.16011 9.81904 1 9.45713 1 9.0857V6.94285C1 6.17142 1.66047 5.54285 2.48106 5.54285H3.49178",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4.4624 3H7.51458",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4.4624 13H7.51458",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M5.98364 3V13",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

export { MediumRename as default };
